import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import InputGroup from "../../components/FormComponent/InputGroup";
import { useEffect, useState } from "react";
import { TableSearch } from "../../components/Table/TableActions";
import Table from "../../components/Table/Table";
import Button from "../../components/Button/Button";
import styles from "./Report.module.css";
import { Grid } from "@mui/material";

// --Dummy Data
import ReportData from "../../dummy_data/reports.json";

const Report = () => {
  const [searchResult, setSearchResult] = useState([]);

  const columns = [
    {
      name: "User ID",
      selector: row => row?.user_id
    },
    {
      name: "School",
      selector: row => row?.school
    },
    {
      name: "Location",
      selector: row => row?.location
    },
    {
      name: "Students",
      selector: row => row?.students
    },
    {
      name: "Staff",
      selector: row => row?.staff
    },
    {
      name: "School Admin",
      selector: row => row?.sch_admin
    },
    {
      name: "Contact mail",
      selector: row => row?.mail
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    // The data will be from the inventory get api endpint
    setSearchResult(ReportData);
  }, []);

  // --| Filter Report table using name, email and class
  const handleAdminSchools = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = ReportData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                    data?.description
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.category
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                      data?.status
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Reports"
            subtitle="Get reports from a list of selected items and articles."
          />
          <div className="margin-bottom">
            <Grid container spacing={2} columnSpacing={2}>
              <Grid item lg={2} md={4} sm={6} xs={12}>
                <InputGroup
                  label="User"
                  margin="normal"
                  placeHolder="Select User"
                  inputType="text"
                />
              </Grid>
              <Grid item lg={2} md={4} sm={6} xs={12}>
                <InputGroup
                  label="Location"
                  margin="normal"
                  placeHolder="Select Location"
                  inputType="text"
                />
              </Grid>
              <Grid item lg={2} md={4} sm={6} xs={12}>
                <InputGroup
                  label="Student Range"
                  margin="normal"
                  placeHolder="Select range"
                  inputType="text"
                />
              </Grid>
              <Grid item lg={2} md={4} sm={6} xs={12}>
                <InputGroup
                  label="Teacher Range"
                  margin="normal"
                  placeHolder="What is the title of label"
                  inputType="text"
                />
              </Grid>
              <Grid item lg={2} md={4} sm={6} xs={12}>
                <div className="margin-top">
                  <Button
                    variant="primary"
                    buttonSize="medium"
                    color="btndefault"
                    buttonName="Filter"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
          <div className={`${styles.HoriRule}`}>
            <hr />
          </div>
          <div className={`${styles.ReportContent} margin-top`}>
            <p>Reports Generated</p>
            <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
              <TableSearch placeholder="Search here..." searchTableFunc={handleAdminSchools} />
            }
            />
          </div>
        </>
      }
    />
  );
};

export default Report;
